import { Component } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import {HeaderComponent} from './components/header/header.component';
import {AirportsSliderComponent} from './components/elements/airports-slider/airports-slider.component';
import {AirportButtonsComponent} from './components/elements/airport-buttons/airport-buttons.component';
import {ModalTermsComponent} from './components/elements/modal-terms/modal-terms.component';
import {ModalService} from './services/modal.service';
import {AsyncPipe} from '@angular/common';


@Component({
  selector: 'app-root',
  imports: [RouterOutlet, HeaderComponent, AirportsSliderComponent, ModalTermsComponent, AsyncPipe],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'meet-plus-greet';

  constructor(public modal: ModalService, public router: Router) {}

  get isMainPage(): boolean {
    return this.router.url === '/';
  }

  get isMobilePreview(): boolean {
    let route = this.router.routerState.snapshot.root;
    while (route) {
      if (route.data['newJourney']) return true;
      if (!route.firstChild) break;
      route = route.firstChild;
    }
    return false;
  }
}
